import type { ReactNode } from "react";
import NextLink from "next/link";
import { useRouter } from "next/router";
import { Link } from "@chakra-ui/react";

interface ActiveLinkProps {
  children: ReactNode;
  href: string;
  isExternal?: boolean;
  prefetch?: boolean;
}

const ActiveLink = ({
  href,
  children,
  isExternal,
  prefetch,
  ...props
}: ActiveLinkProps) => {
  const { asPath } = useRouter();

  const checkPathMatch = () => {
    if (href.includes("http")) {
      return false;
    }

    if (href === "/") {
      if (asPath === "/") {
        return true;
      }

      return false;
    }

    const hrefStart = href.split("/")[1];

    return asPath.substring(1).startsWith(hrefStart);
  };

  const isSelected = checkPathMatch();

  return (
    <Link
      as={NextLink}
      href={href}
      isExternal={isExternal}
      color="white"
      fontWeight="600"
      outline="none"
      rounded="md"
      transition=".2s all"
      p={2}
      bg={isSelected ? "blackAlpha.400" : "transparent"}
      _hover={
        !isSelected && {
          bg: "blackAlpha.300",
        }
      }
      _active={{
        bg: "blackAlpha.400",
      }}
      _focus={{
        boxShadow: "outline-light",
      }}
      {...props}
    >
      {children}
    </Link>
  );
};

export default ActiveLink;
